module.exports = __webpack_public_path__ + "img/ico-man.55e01ecb.svg";